import { HttpDataService, IHttpDataCache } from '../http/http-data.service';
import { ICodeValue, IFaq } from '@type_definitions/datatypes';
import { Injectable } from '@angular/core';
import { IMailRequest } from '../send-mail/send-mail-data.service';
import { IFaqRequest, IFaqResponse } from '@app/main/faq/list/faq-search.component';
export const ACSL_PERMISSION:string = 'acslDisplay';

@Injectable()
export class FaqDataService {
  private cache:IHttpDataCache<any>;

  constructor(
    private httpDataService:HttpDataService
  ) {
    this.cache = httpDataService.createCache();
  }

  public listFaqs(keyword?:string, webshopId?:number, filter?:string):Promise<IFaq[]> {
    return this.httpDataService.doGET(
      'rest/faqs',
      {
        keyword,
        filter,
        webshopId
      },
      undefined,
      'Error loading FAQs'
    );
  }

  public sendFaqs(sendMailModel: IMailRequest, keyword?:string, webshopId?:number, filter?:string, faqId?:number):Promise<IFaq[]> {
    return this.httpDataService.doPOST(
      'rest/faqs/send',
      faqId ? { faqId } : { keyword, filter, webshopId },
      sendMailModel,
      undefined,
      'Error sending FAQs'
    );
  }

  public getFaq(id:number):Promise<IFaq> {
    return this.cache.doGET(
      `rest/faqs/faq/${id}`,
      undefined,
      undefined,
      'Error loading FAQ'
    );
  }

  public getFaqByCode(code:string):Promise<IFaq> {
    return this.httpDataService.doGET(
      'rest/faqs/faq',
      { code }
    );
  }

  public searchFaq(faqRequest:IFaqRequest):Promise<IFaqResponse> {
    return this.httpDataService.doPOST(
      'rest/faqs/faq-search',
      null,
      faqRequest,
      undefined,
      'Error searching FAQ'
    );
  }

  public createFaq(data:IFaq):Promise<IFaq> {
    return this.httpDataService.doPOST(
      'rest/faqs/faq',
      undefined,
      data,
      'Saving FAQ…',
      'Error creating FAQ'
    );
  }

  public updateFaq(faqId:number, data:IFaq):Promise<IFaq> {
    return this.httpDataService.doPUT(
      `rest/faqs/faq/${faqId}`,
      undefined,
      data,
      'Saving FAQ…',
      'Error saving FAQ'
    );
  }

  public getFaqManuals():Promise<ICodeValue[]> {
    return this.httpDataService.doGET(
      'rest/faqs/manuals',
      undefined,
      undefined,
      'Error loading manuals'
    );
  }

  public getFaqKeywords():Promise<ICodeValue[]> {
    return this.httpDataService.doGET(
      'rest/faqs/keywords',
      undefined,
      undefined,
      'Error loading keywords'
    );
  }

  public getFaqPossiblePermissions = ():ICodeValue[] => [
    {
      id: ACSL_PERMISSION,
      value: 'ACSL'
    },
    {
      id: 'bpDisplay',
      value: 'BP'
    },
    {
      id: 'customerDisplay',
      value: 'Customer'
    },
    {
      id: 'vendorDisplay',
      value: 'Vendor'
    },
    {
      id: 'otherDisplay',
      value: 'Other'
    }
  ];

  public clear():void {
    this.cache.clear();
  }
}